import { Tooltip } from '@mui/material';
import { TableIconButton } from '../../../../components/Styled';
import Icon from '../../../../components/FormControl/Icon';
import styles from '../header.module.scss';
import useBoolean from 'hooks/useToggle';
import Sidebar from './Sidebar';
import { LearnMoreSectionProps } from './types';

const LearnMoreSection: React.FC<LearnMoreSectionProps> = ({ screenKey }) => {
  const { value: isSidebarOpen, toggle: toggleSidebar, setFalse: closeSidebar } = useBoolean(false);

  return (
    <>
      <Tooltip title={'Learn More'} placement='left'>
        <TableIconButton onClick={toggleSidebar}>
          <Icon icon={'ri-youtube-fill'} size={'1.2rem'} className={styles.learnMoreIcon} />
        </TableIconButton>
      </Tooltip>
      {isSidebarOpen ? (
        <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} screenKey={screenKey} />
      ) : null}
    </>
  );
};

export default LearnMoreSection;
